export default "__VITE_ASSET__Bvx4POIL__"